import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Paragraph from '../../../../components/common/Paragraph';
import './styles.less';


const InfoLeyArt150 = () => {
    const [isModalVisible, setModalVisible] = useState(false);

    const hideModal = () => setModalVisible(false);
    const openModal = () => setModalVisible(true);

    const modalFooter = (
        <Button type="primary" onClick={hideModal}>
            Entendido
        </Button>
    );

    return (
        <>
            <Button
                size="small"
                type="link"
                style={{ paddingLeft: '2px', paddingRight: '2px' }}
                onClick={openModal}
            >
                <h1 className='modalInfoArt150__title'>Artículo 150 del Código Civil?</h1>
            </Button>
            <InfoCircleOutlined className="modalInfoArt150__info" />
            <Modal footer={modalFooter} visible={isModalVisible} onCancel={hideModal} width={780}>
                <Paragraph strong>Artículo 150 del Código Civil</Paragraph>
                <Paragraph align="justify">
                    La mujer casada de cualquiera edad podrá dedicarse libremente al ejercicio de un empleo, oficio, profesión o industria.
                    La mujer casada, que desempeñe algún empleo o que ejerza una profesión, oficio o industria, separados de los de su marido, se considerará separada de bienes respecto del ejercicio de ese empleo, oficio, profesión o industria y de lo que en ellos obtenga, no obstante cualquiera estipulación en contrario; pero si fuere menor de dieciocho años, necesitará autorización judicial, con conocimiento de causa, para gravar y enajenar los bienes raíces.
                    Incumbe a la mujer acreditar, tanto respecto del marido como de terceros, el origen y dominio de los bienes adquiridos en conformidad a este artículo. Para este efecto podrá servirse de todos los medios de prueba establecidos por la ley.
                    Los terceros que contraten con la mujer quedarán a cubierto de toda reclamación que pudieren interponer ella o el marido, sus herederos o cesionarios, fundada en la circunstancia de haber obrado la mujer fuera de los términos del presente artículo, siempre que, no tratándose de bienes comprendidos en los artículos 1754 y 1755, se haya acreditado por la mujer, mediante instrumentos públicos o privados, a los que se hará referencia en el instrumento que se otorgue al efecto, que ejerce o ha ejercido un empleo, oficio, profesión o industria separados de los de su marido.
                </Paragraph>
            </Modal>
        </>
    );
};

export default InfoLeyArt150;
